// extracted by mini-css-extract-plugin
module.exports = {"cls1":"ToggleButton-Bar-module--cls1--27-ah","cls2":"ToggleButton-Bar-module--cls2--112nZ ToggleButton-Bar-module--cls1--27-ah"};